import { useInterventionData, setInterventionData } from '../../context/intervention/intervention';

const useIntervention = () => {
  const currentInterventionData = useInterventionData();

  return {
    currentInterventionData,
    setInterventionData,
  };
};

export default useIntervention;
